import { t, useStoreLanguage } from "../../features/store-language/i18n.ts";
import React from "react";
import { Drawer, Empty } from "antd";
import "../shared/RichTextEditor/RichTextEditor.css";
import "./Guides.css";

interface GuidesDrawerItem {
  id: number;
  title: string;
  description: string;
  path?: string;
}

interface GuidesDrawerProps {
  open: boolean;
  onClose: () => void;
  guides: GuidesDrawerItem[];
}

function getDrawerTitle(guides: GuidesDrawerItem[]): string {
  const titles = guides
    .map(function (guide) {
      return (guide.title || "").trim();
    })
    .filter(function (title) {
      return title.length > 0;
    });

  if (titles.length === 0) {
    return t("راهنمای این بخش");
  }

  return t("راهنمای {{value0}}", { value0: titles.join("، ") });
}

/**
 * کشوی نمایش راهنماهای صفحه. برای نوار Breadcrumb (راهنماهای مسیر جاری) و
 * عملیات «مشاهده» در صفحه مدیریت راهنماها استفاده می‌شود.
 */
const GuidesDrawer: React.FC<GuidesDrawerProps> = function (props) {
  useStoreLanguage();
  const { open, onClose, guides } = props;
  const items = Array.isArray(guides) ? guides : [];

  return (
    <Drawer
      title={getDrawerTitle(items)}
      placement="right"
      width={680}
      open={open}
      onClose={onClose}
      className="guides-drawer"
    >
      {items.length === 0 && (
        <Empty description={t("راهنمایی برای این بخش ثبت نشده است")} />
      )}
      {items.length > 0 && (
        <div className="guides-list">
          {items.map((guide) => (
            <div key={guide.id} className="guide-card">
              <div
                className="rte-display guide-card__content"
                dangerouslySetInnerHTML={{ __html: guide.description || "" }}
              />
            </div>
          ))}
        </div>
      )}
    </Drawer>
  );
};

export default GuidesDrawer;
